window.addEventListener('load', function() {
  document.getElementById('warranty_id')?.addEventListener('change', function() {
    document.getElementById('warranty_cart_id').disabled = !this.checked;
    document.getElementById('warranty_quantity_id').disabled = !this.checked;
    document.getElementById('warranty_properties').disabled = !this.checked;
  });

  document.getElementById('Quantity-product-template')?.addEventListener('change', function(e) {
    document.getElementById("warranty_quantity_id").setAttribute('value', e.target.value);
  });

  document.querySelectorAll('.cart__remove').forEach(function(element) {
    element.addEventListener('click', function(e) {
      e.preventDefault();
      if (!e.target.matches('.cart__remove')) return;
      let product_name = e.target.getAttribute("aria-label").split('Remove ')[1];
      const parentNode = document.querySelectorAll('tbody tr');
      var index = 0;
      var amount = 0;
      for (var node of parentNode) {
        index++;
        var flag = node.querySelector('.cart__remove').getAttribute("aria-label").includes("Warranty");
        if (!flag) continue;
        var properties = node.querySelector('.option-cart-title-content').innerText;
        if (!properties) continue;
        if (properties.includes(product_name)) {
          amount = +node.querySelector(".cart__qty-input").value;
          break;
        }
      }
      const quantity = +e.target.parentNode.parentNode.parentNode.querySelector(".cart__qty-input").value;
      const final_quantity = Math.max(amount - quantity, 0);

      setTimeout(function() {
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({'line': index, 'quantity': final_quantity})
        })
        .then(response => {
          location.reload();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }, 200);
    });
  });
});
